import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import styled from 'styled-components';

export const LoginCard = styled(Card)`
	width: 100%;
	max-width: 360px;
`;

export const LoginCardContent = styled(CardContent)`
	padding: 36px;
`;
